<template><AdminServiceList kind="rent" /></template>
<script setup>import AdminServiceList from "@/components/catalog/AdminServiceList.vue";</script>
